import React, { Component } from 'react';
import 'react-table/react-table.css';
import ExtranetNavbar from './Components/Extranet/ExtranetNavbar.js';
import ExtranetBreadcrumb from './Components/Extranet/ExtranetBreadcrumb';
import ExtranetTitle from './Components/Extranet/ExtranetTitle';
import ExtranetSubNav from './Components/Extranet/ExtranetSubNav.js';
import ExtranetMain from './Components/Extranet/ExtranetMain.js';
import update from 'immutability-helper';
import { getMenuItems } from './Utilities/SnsExtranetFunctions';
import { getJsonItem } from './Utilities/JsonFunctions.js';
import { getExtranetOrganisationInfo, getProjectCounters, getCandidateCounters } from './Api/ExtranetActions.js';
import { getTranslation } from './Utilities/GetTranslation.js';

declare var globalSns;
declare var globalExtranet;

const extranetStartPage = "extranetHome";
const extranetSubPages = {
    extranetProjects: [
        'extranetProjectsFiche',
        'extranetProjectsCandidates',
        'extranetProjectsDocuments',
        'extranetProjectsMessages'
    ],
    extranetCandidates: [
        'extranetCandidatesFiche',
        'extranetCandidatesProjects',
        'extranetCandidatesDocuments',
        'extranetCandidatesMessages'
    ]
}

class AppExtranet extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeComponent: extranetStartPage,
            activeNav: null,
            activeSubNav: null,
            breadCrumbMenuItems: [],
            historyItems: []
        }

        this.onNavigate = this.onNavigate.bind(this);
        this.onSubNavigate = this.onSubNavigate.bind(this);
    }

    componentWillMount() {
        this.loadData(null);
    }

    componentDidMount() {
        this._isMounted = true;
        window.onpopstate = () => {
          if(this._isMounted) {
            let pageId = new URLSearchParams(window.location.search).get("pageId");
            let historyItem = getJsonItem(this.state.historyItems, "pageId", pageId);

            if (historyItem == null) {
                return;
            }

            this.loadData(historyItem.pageId, historyItem.id, historyItem.title, null, historyItem.breadCrumbMenuItems);
          }
        }
    }

    async loadData(pageId, id, title, data, historyBreadCrumbMenuItems) {
        let extranetOrganisationInfo = this.state.extranetOrganisationInfo;
        if (pageId == null) {
            pageId = extranetStartPage;
            
            extranetOrganisationInfo = await this.loadExtranetOrganisationInfo();
            
            if (extranetOrganisationInfo != null) {
                title = getTranslation("sns.general.extranet.welcome") + " " + extranetOrganisationInfo.firstName;
                globalExtranet.pages.extranetCandidates.nr = extranetOrganisationInfo.nrNewCandidates;
                globalExtranet.pages.extranetDocuments.nr = extranetOrganisationInfo.nrNewDocuments;
                globalExtranet.pages.extranetMessages.nr = extranetOrganisationInfo.nrNewMessages;
                globalExtranet.showOpenOnly = extranetOrganisationInfo.showOpenOnly;
            }
        }

        let activeTitle = "";
        let activeClassName = "";

        let activeComponent = globalExtranet.pages[pageId];
        
        if (activeComponent != null) {
            activeTitle = activeComponent.title;
            activeClassName = activeComponent.className;    
        }
        if (title != null) {
            activeTitle = title;
        }

        let subnavKey = this.getSubNavigationKey(pageId);
        let subnavData = (subnavKey == null) ? null : await this.getSubNavigationData(subnavKey, id);
        let activeNav = (subnavKey == null) ? pageId : subnavKey;
        let breadCrumbMenuItems = (historyBreadCrumbMenuItems) ? historyBreadCrumbMenuItems : this.getBreadCrumbMenuItems(pageId, id, activeTitle, subnavKey == null);
        let historyItems = (historyBreadCrumbMenuItems) ? this.state.historyItems : this.addBrowserHistory(pageId, id, activeTitle, breadCrumbMenuItems);

        this.setState({
            activeComponent: pageId,
            activeId: id,
            activeNav: activeNav,
            activeSubNav: subnavData,
            activeTitle: activeTitle,
            activeClassName: activeClassName,
            activeData: data,
            breadCrumbMenuItems: breadCrumbMenuItems,
            historyItems: historyItems,
            extranetOrganisationInfo: extranetOrganisationInfo
        });
    }

    loadExtranetOrganisationInfo() {
        return new Promise(ok => {
            getExtranetOrganisationInfo(globalSns.languageId, (data) => {
                ok(data);
            });
        });
    }

    loadProjectCounters(id) {
        return new Promise(ok => {
            getProjectCounters(id, (data) => {
                ok(data);
            });
        });
    }

    loadCandidateCounters(id) {
        return new Promise(ok => {
            getCandidateCounters(id, (data) => {
                ok(data);
            });
        });
    }

    getBreadCrumbMenuItems(pageId, id, activeTitle, clearCrumb) {
        var breadCrumbMenuItems = this.state.breadCrumbMenuItems;
        var item = getJsonItem(breadCrumbMenuItems, "pageId", pageId);
           
        if (clearCrumb) {
            // New breadcrumb starting from first (home)
            breadCrumbMenuItems = update(breadCrumbMenuItems, {$splice: [[1 , breadCrumbMenuItems.length - 1]]});
        } else {

            if (item != null) {
                // Goes to an existing breadcrumb point, clears breadcrumb starting from that point
                var index = breadCrumbMenuItems.indexOf(item);
                var erase = breadCrumbMenuItems.length - index;

                breadCrumbMenuItems = update(breadCrumbMenuItems, {$splice: [[breadCrumbMenuItems.length - erase, erase]]});            
            }

            if (breadCrumbMenuItems.length > 3) {
                // Deep/cross navigating, clears breadcrumb starting from home > projects-or-candidates > ...
                breadCrumbMenuItems = update(breadCrumbMenuItems, {$splice: [[2 , breadCrumbMenuItems.length - 2]]});
            }

        }

        if (pageId === extranetStartPage) {
            // We are back on the homepage ( only 1 crumb )
            return [{pageId: extranetStartPage, id: null, title: activeTitle}];
        }

        // Adds the page to the crumb
        return update(breadCrumbMenuItems, {$push: [{pageId: pageId, id: id, title: activeTitle}]});        
    }

    getBreadCrumbMenuItemsSubNav(pageId) {
        let breadCrumbMenuItems = this.state.breadCrumbMenuItems
        
        breadCrumbMenuItems = update(breadCrumbMenuItems, {$splice: [[breadCrumbMenuItems.length - 1, 1]]})
        breadCrumbMenuItems = update(breadCrumbMenuItems, {$push: [{pageId: pageId, id: this.state.activeId, title: this.state.activeTitle}]});        

        return breadCrumbMenuItems;
    }

    // Get's the tab navigation and search the counters
    async getSubNavigationData(subnavKey, id) {
        let subnavRecord = extranetSubPages[subnavKey];
        if (subnavRecord == null)
            return null;

        if (subnavKey === "extranetProjects") {
            let projectCounters = await this.loadProjectCounters(id);
            if (projectCounters != null) {
                globalExtranet.pages.extranetProjectsCandidates.nr = projectCounters.nrCandidates;
                globalExtranet.pages.extranetProjectsDocuments.nr = projectCounters.nrDocuments;
                globalExtranet.pages.extranetProjectsMessages.nr = projectCounters.nrMessages;
            }
        }
        if (subnavKey === "extranetCandidates") {
            let candidateCounters = await this.loadCandidateCounters(id);
            if (candidateCounters != null) {
                globalExtranet.pages.extranetCandidatesProjects.nr = candidateCounters.nrProjects;
                globalExtranet.pages.extranetCandidatesDocuments.nr = candidateCounters.nrDocuments;
                globalExtranet.pages.extranetCandidatesMessages.nr = candidateCounters.nrMessages;                
            }
        }

        let menuItems = getMenuItems(globalExtranet.pages, this.state.activeComponent);
        let subMenuItems = [];
        subnavRecord.forEach(function (item) {
            subMenuItems.push(getJsonItem(menuItems, "id", item));
        });

        return subMenuItems;
    }

    getSubNavigationKey(pageId) {
        for (var key in extranetSubPages) {
            if (extranetSubPages[key].includes(pageId)) {
                return key;
            }
        }
        return null;
    }

    addBrowserHistory(pageId, id, activeTitle, breadCrumbMenuItems) {
        let historyItems = this.state.historyItems;
        let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?pageId=" + pageId;
        window.history.pushState({path:newurl},'',newurl);

        let item = getJsonItem(historyItems, "pageId", pageId);

        if (item == null) {
            return update(historyItems, {$push: [{pageId: pageId, id: id, title: activeTitle, breadCrumbMenuItems: breadCrumbMenuItems}]});
        } else {
            let index = historyItems.indexOf(item);
            return update(historyItems, {[index]: {$set: {pageId: pageId, id: id, title: activeTitle, breadCrumbMenuItems: breadCrumbMenuItems}}})
        }  
    }

    onNavigate(pageId, id, title, data) {
        this.loadData(pageId, id, title, data);
    }

    onSubNavigate(pageId, data) {
        let breadCrumbMenuItems = this.getBreadCrumbMenuItemsSubNav(pageId);
        let historyItems = this.addBrowserHistory(pageId, this.state.activeId, this.state.activeTitle, breadCrumbMenuItems);

        this.setState({
            activeComponent: pageId,
            activeData: data,
            breadCrumbMenuItems: breadCrumbMenuItems,
            historyItems: historyItems
        });
    }

    render() {
        return (
            <div className="container-fluid">
                <ExtranetNavbar menuitems={getMenuItems(globalExtranet.pages, this.state.activeNav)} onNavigate={this.onNavigate} />
                <ExtranetBreadcrumb menuitems={this.state.breadCrumbMenuItems} onNavigate={this.onNavigate} />
                <ExtranetTitle title={this.state.activeTitle} 
                    logoId={this.state.extranetOrganisationInfo == null ? null : this.state.extranetOrganisationInfo.logoId} 
                    organisationName={this.state.extranetOrganisationInfo == null ? null : this.state.extranetOrganisationInfo.organisationName} 
                    className={this.state.activeClassName} />
                <ExtranetSubNav activeComponent={this.state.activeComponent} activeSubNav={this.state.activeSubNav} onSubNavigate={this.onSubNavigate} />
                <ExtranetMain activeComponent={this.state.activeComponent} activeId={this.state.activeId} activeTitle={this.state.activeTitle} activeData={this.state.activeData} onNavigate={this.onNavigate} onSubNavigate={this.onSubNavigate} />
            </div>
        );
    }
}

export default AppExtranet;


// WEBPACK FOOTER //
// ./src/AppExtranet.js